import React, { useCallback, useEffect, useMemo, useState } from 'react'
import KapalService from '../../../../services/kapal/KapalService'
import Card from '../../../../components/Card'
import { Button, OverlayTrigger, Spinner, Tooltip } from 'react-bootstrap'
import DisposisiKapal from '../../../../utilities/kapal/DisposisiKapal'
import { formatDateTimeLocalDate } from '../../../../utilities/Utils'
import { FaBook, FaEdit, FaEye, FaFile, FaFileAlt, FaFileDownload, FaFilePdf, FaPaperPlane, FaTasks } from 'react-icons/fa'
import ModalEvp from '../modal/ModalEvp'
import ModalSpt from '../modal/ModalSpt'
import ModalSt from '../modal/ModalSt'
import ModalBatalInspeksi from '../modal/ModalBatalInspeksi'
import ModalAuditKecukupan from '../modal/ModalAuditKecukupan'
import ModalInspeksi from '../modal/ModalInspeksi'
import ModalReviuRekom from '../modal/ModalReviuRekom'
import ModalTindakLanjutSt from '../modal/ModalTindakLanjutSt'
import ModalDataUmum from '../modal/ModalDataUmum'
import ModalInspeksiChecklist from '../modal/ModalInspeksiChecklist'
import ModalInspeksiChecklistHasil from '../modal/ModalInspeksiChecklistHasil'
import ModalRekom from '../modal/ModalRekom'
import ModalApproval from '../modal/ModalApproval'
import ModalPreview from '../modal/ModalPreview'
import ModalPreviewTte from '../modal/ModalPreviewTte'
import ModalTindakLanjutSP from '../modal/ModalTindakLanjutSP'
import ModalProsesST from '../modal/ModalProsesST'
import ModalTindakLanjutEvp from '../modal/ModalTindakLanjutEvp'

const ExpandableComponentKapal = ({ data, reloadList }) => {
    let kapalService = useMemo(() => new KapalService(), [])
    const [listDisposisi, setListDisposisi] = useState([])
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        const getDisposisi = async () => {
            setLoading(true)
            try {
                const resPenugasan = await kapalService.listPenugasanAll(data.nomorAjuKapal)
                setListDisposisi(resPenugasan.data.data)
            } catch (error) {
                console.log(error)
            }
            setLoading(false)
        }
        getDisposisi()
    }, [kapalService, data])
    return (
        <>
            <Card>
                <Card.Body>
                    {loading && <Spinner />}
                    <div className="iq-timeline0 m-0 d-flex align-items-center justify-content-between position-relative">
                        <ul className="list-inline p-0 m-0 w-100">
                            {
                                listDisposisi.map((disp, index) => {
                                    return (
                                        <li key={index}>
                                            <div className="timeline-dots timeline-dot1 border-danger text-primary"></div>
                                            <h6 className="float-left mb-1"><DisposisiKapal idDisposisi={disp.idDisposisi} /></h6>
                                            <small>Nomor : {disp.noTugas} / Tanggal : {disp.tglTugas !== null && formatDateTimeLocalDate(disp.tglTugas)}</small>
                                            {
                                                disp.idDisposisi === 8 && disp.noTugas !== null &&
                                                <>
                                                    <div className="d-inline-block w-100">
                                                        <small>Nomor Sertifikat : <strong><GetNomorSertifikatKapal nomorAjuKapal={data.nomorAjuKapal} namaKapal={data.namaKapal} idDisposisi={disp.idDisposisi} /></strong></small>
                                                    </div>
                                                    <div className="d-inline-block w-100">
                                                        <small>Status : <strong><GetStatusTteSertifikat nomorAjuKapal={data.nomorAjuKapal} namaKapal={data.namaKapal} idDisposisi={disp.idDisposisi} /></strong></small>
                                                    </div>
                                                </>
                                            }
                                            {
                                                disp.idDisposisi === 9 && disp.noTugas !== null &&
                                                <>
                                                    <div className="d-inline-block w-100">
                                                        <small>Status SPT : <strong><GetStatusTteSpt nomorAjuKapal={data.nomorAjuKapal} idDisposisi={disp.idDisposisi} noTugas={disp.noTugas} /></strong></small>
                                                    </div>
                                                </>
                                            }
                                            <div className="d-inline-block w-100">
                                                <DisposisiProses dataPpmKapal={data} dataPenugasan={disp} reloadList={reloadList} />
                                            </div>
                                        </li>
                                    )
                                })
                            }
                        </ul>
                    </div>
                </Card.Body>
            </Card>
        </>
    )
}

const DisposisiProses = ({ dataPpmKapal, dataPenugasan, reloadList }) => {

    const [dataDisposisi, setDataDisposisi] = useState(null)
    const [isEdit, setIsEdit] = useState(false)

    const [showEvp, setShowEvp] = useState(false)
    const handleCloseEvp = () => {
        setShowEvp(false)
    }
    const [showSpt, setShowSpt] = useState(false)
    const handleCloseSpt = () => {
        setShowSpt(false)
    }
    const [showSt, setShowSt] = useState(false)
    const handleCloseSt = () => {
        setShowSt(false)
    }
    const [showBatalInspeksi, setShowBatalInspeksi] = useState(false)
    const handleCloseBatalInspeksi = () => {
        setShowBatalInspeksi(false)
    }
    const [showAudit, setShowAudit] = useState(false)
    const handleCloseAudit = () => {
        setShowAudit(false)
    }
    const [showInspeksi, setShowInspeksi] = useState(false)
    const handleCloseInspeksi = () => {
        setShowInspeksi(false)
    }
    const [showReviuRekom, setShowReviuRekom] = useState(false)
    const handleCloseReviuRekom = () => {
        setShowReviuRekom(false)
    }
    const [showApproval, setShowApproval] = useState(false)
    const handleCloseApproval = () => {
        setShowApproval(false)
    }
    //tindak lanjut SP
    const [showTLSP, setShowTLSP] = useState(false)
    const handleCloseTLSP = () => {
        setShowTLSP(false)
    }

    const [showTLEvp, setShowTLEvp] = useState(false)
    const handleCloseTLEvp = () => {
        setShowTLEvp(false)
    }

    const handleShow = (dataPenugasan, isEdit) => {
        setDataDisposisi(dataPenugasan)
        setIsEdit(isEdit)
        if (dataPenugasan.idDisposisi === 1) {
            setShowEvp(true)
        } else if (dataPenugasan.idDisposisi === 9) {
            setShowSpt(true)
        } else if (dataPenugasan.idDisposisi === 2) {
            setShowSt(true)
        } else if (dataPenugasan.idDisposisi === 3) {
            setShowAudit(true)
        } else if (dataPenugasan.idDisposisi === 4) {
            setShowBatalInspeksi(true)
        } else if (dataPenugasan.idDisposisi === 5) {
            setShowInspeksi(true)
            setIsEdit(true)
        } else if (dataPenugasan.idDisposisi === 7) {
            setShowReviuRekom(true)
        } else if (dataPenugasan.idDisposisi === 8) {
            setShowApproval(true)
        } else if (dataPenugasan.idDisposisi === 19) {
            setShowTLSP(true)
        } else if (dataPenugasan.idDisposisi === 21) {
            setShowTLEvp(true)
        }
    }

    const [showTlSt, setShowTlSt] = useState(false)
    const handleCloseTlST = () => {
        setShowTlSt(false)
    }
    const handleTindalLanjut = (dataPenugasan, isEdit) => {
        setDataDisposisi(dataPenugasan)
        setIsEdit(isEdit)
        setShowTlSt(true)
    }

    const [showProsesST, setShowProsesST] = useState(false)
    const handleCloseProsesST = () => {
        setShowProsesST(false)
    }
    const handleProsesST = (isEdit) => {
        setIsEdit(isEdit)
        setShowProsesST(true)
    }

    const [showDataUmum, setShowDataUmum] = useState(false)
    const handleCloseDataUmum = () => {
        setShowDataUmum(false)
    }
    const handleViewDataUmum = (dataPenugasan, isEdit) => {
        setDataDisposisi(dataPenugasan)
        setIsEdit(isEdit)
        setShowDataUmum(true)
    }

    const [showChecklist, setShowChecklist] = useState(false)
    const handleCloseChecklist = () => {
        setShowChecklist(false)
    }
    const handleViewChecklist = (dataPenugasan, isEdit) => {
        setDataDisposisi(dataPenugasan)
        setIsEdit(isEdit)
        setShowChecklist(true)
    }

    const [showHasilInspeksi, setShowHasilInspeksi] = useState(false)
    const handleCloseHasilInspeksi = () => {
        setShowHasilInspeksi(false)
    }
    const handleViewHasilInspeksi = (dataPenugasan, isEdit) => {
        setDataDisposisi(dataPenugasan)
        setIsEdit(isEdit)
        setShowHasilInspeksi(true)
    }

    const [showRekom, setShowRekom] = useState(false)
    const handleCloseRekom = () => setShowRekom(false)
    const handleViewRekom = (dataPenugasan, isEdit) => {
        setDataDisposisi(dataPenugasan)
        setIsEdit(isEdit)
        setShowRekom(true)
    }

    const [showPreview, setShowPreview] = useState(false)
    const handleClosePreview = () => setShowPreview(false)
    const handleClickPreview = (dataPenugasan) => {
        setDataDisposisi(dataPenugasan)
        setShowPreview(true)
    }

    const [showViewTte, setShowViewTte] = useState(false)
    const handleCloseViewTte = () => setShowViewTte(false)
    const handleClickViewTte = (dataPenugasan) => {
        setDataDisposisi(dataPenugasan)
        setShowViewTte(true)
    }

    return (
        <>
            <div className="row">
                <div className="col-sm-8">
                    {
                        ((localStorage.getItem("role") !== '4' && localStorage.getItem("role") !== '5' && localStorage.getItem("role") !== '8') && dataPenugasan.noTugas === null) &&
                        <>
                            <OverlayTrigger placement="bottom" overlay={
                                <Tooltip >Proses</Tooltip>
                            }>
                                <Button size="sm" variant="outline-primary" onClick={() => handleShow(dataPenugasan, true)}>
                                    <FaPaperPlane /> Proses
                                </Button>
                            </OverlayTrigger>{' '}
                        </>
                    }
                    {
                        dataPenugasan.noTugas !== null &&
                        <>
                            {(dataPenugasan.idDisposisi !== 20 && dataPenugasan.idDisposisi !== 4)  && <OverlayTrigger placement="bottom" overlay={
                                <Tooltip >Lihat</Tooltip>
                            }>
                                <Button size="sm" variant="outline-info" onClick={() => handleShow(dataPenugasan, false)}>
                                    <FaEye /> Lihat
                                </Button>
                            </OverlayTrigger>
                            }{' '}
                            {dataPenugasan.idDisposisi !== 19 &&
                                <OverlayTrigger placement="bottom" overlay={
                                    <Tooltip >Preview PDF</Tooltip>
                                }>
                                    <Button size="sm" variant="outline-warning" onClick={() => handleClickPreview(dataPenugasan)}>
                                        <FaFilePdf /> Preview PDF
                                    </Button>
                                </OverlayTrigger>
                            }{' '}
                        </>
                    }
                    {
                        dataPenugasan.idDisposisi === 2 && dataPenugasan.noTugas !== null && dataPpmKapal.kodeStatus === '022' &&
                        <>
                            <OverlayTrigger placement="bottom" overlay={
                                <Tooltip >Tindak Lanjut ST</Tooltip>
                            }>
                                <Button size="sm" variant="outline-secondary" onClick={() => handleTindalLanjut(dataPenugasan, true)}>
                                    <FaEdit /> Tindak Lanjut ST
                                </Button>
                            </OverlayTrigger>{' '}

                        </>
                    }
                    {
                        dataPenugasan.idDisposisi === 5 && dataPenugasan.noTugas !== null &&
                        <>
                            <OverlayTrigger placement="bottom" overlay={
                                <Tooltip >Data Umum Kapal</Tooltip>
                            }>
                                <Button size="sm" variant="outline-secondary" onClick={() => handleViewDataUmum(dataPenugasan, true)}>
                                    <FaFileAlt /> Data Umum Kapal
                                </Button>
                            </OverlayTrigger>{' '}
                            <OverlayTrigger placement="bottom" overlay={
                                <Tooltip >Checklist Kapal</Tooltip>
                            }>
                                <Button size="sm" variant="outline-secondary" onClick={() => handleViewChecklist(dataPenugasan, true)}>
                                    <FaFile /> Data Checklist
                                </Button>
                            </OverlayTrigger>{' '}
                            <OverlayTrigger placement="bottom" overlay={
                                <Tooltip >Hasil Inspeksi ke Pusat</Tooltip>
                            }>
                                <Button size="sm" variant="primary" onClick={() => handleViewHasilInspeksi(dataPenugasan, true)}>
                                    <FaBook /> Hasil Inspeksi
                                </Button>
                            </OverlayTrigger>
                        </>
                    }
                    {
                        dataPenugasan.idDisposisi === 7 && dataPenugasan.noTugas !== null &&
                        <>
                            <OverlayTrigger placement="bottom" overlay={
                                <Tooltip >Rekomendasi</Tooltip>
                            }>
                                <Button size="sm" variant="outline-secondary" onClick={() => handleViewRekom(dataPenugasan, true)}>
                                    <FaTasks /> Rekomendasi
                                </Button>
                            </OverlayTrigger>{' '}
                        </>
                    }
                    {
                        dataPenugasan.idDisposisi === 8 && dataPenugasan.noTugas !== null &&
                        <>
                            <OverlayTrigger placement="bottom" overlay={
                                <Tooltip >Preview Sertifikat TTE</Tooltip>
                            }>
                                <Button size="sm" variant="success" onClick={() => handleClickViewTte(dataPenugasan)}>
                                    <FaFileDownload /> Dokumen Sertifikat TTE
                                </Button>
                            </OverlayTrigger>{' '}
                        </>
                    }
                    {
                        dataPenugasan.idDisposisi === 9 && dataPenugasan.noTugas !== null &&
                        <>
                            <OverlayTrigger placement="bottom" overlay={
                                <Tooltip >Preview SPT TTE</Tooltip>
                            }>
                                <Button size="sm" variant="success" onClick={() => handleClickViewTte(dataPenugasan)}>
                                    <FaFileDownload />Dokumen SPT TTE
                                </Button>
                            </OverlayTrigger>{' '}
                        </>
                    }
                    {
                        dataPenugasan.idDisposisi === 20 && dataPenugasan.noTugas !== null && dataPpmKapal.kodeStatus === '051' &&
                        <>
                            <OverlayTrigger placement="bottom" overlay={
                                <Tooltip >Proses ST</Tooltip>
                            }>
                                <Button size="sm" variant="primary" onClick={() => handleProsesST(true)}>
                                    <FaPaperPlane /> Proses Surat Tugas
                                </Button>
                            </OverlayTrigger>{' '}

                        </>
                    }
                </div>
            </div>
            <ModalEvp showEvp={showEvp} handleCloseEvp={handleCloseEvp} dataPpmKapal={dataPpmKapal} dataDisposisi={dataDisposisi} reloadList={reloadList} isEdit={isEdit} />
            <ModalSpt showSpt={showSpt} handleCloseSpt={handleCloseSpt} dataPpmKapal={dataPpmKapal} dataDisposisi={dataDisposisi} reloadList={reloadList} isEdit={isEdit} />
            <ModalSt showSt={showSt} handleCloseSt={handleCloseSt} dataPpmKapal={dataPpmKapal} dataDisposisi={dataDisposisi} reloadList={reloadList} isEdit={isEdit} />
            <ModalBatalInspeksi showBatalInspeksi={showBatalInspeksi} handleCloseBatalInspeksi={handleCloseBatalInspeksi} dataPpmKapal={dataPpmKapal} dataDisposisi={dataDisposisi} reloadList={reloadList} isEdit={isEdit} />
            <ModalAuditKecukupan showAudit={showAudit} handleCloseAudit={handleCloseAudit} dataPpmKapal={dataPpmKapal} dataDisposisi={dataDisposisi} reloadList={reloadList} isEdit={isEdit} />
            <ModalInspeksi showInspeksi={showInspeksi} handleCloseInspeksi={handleCloseInspeksi} dataPpmKapal={dataPpmKapal} dataDisposisi={dataDisposisi} reloadList={reloadList} isEdit={isEdit} />
            <ModalReviuRekom showReviuRekom={showReviuRekom} handleCloseReviuRekom={handleCloseReviuRekom} dataPpmKapal={dataPpmKapal} dataDisposisi={dataDisposisi} reloadList={reloadList} isEdit={isEdit} />
            <ModalTindakLanjutSt showTlSt={showTlSt} handleCloseTlST={handleCloseTlST} dataPpmKapal={dataPpmKapal} dataDisposisi={dataDisposisi} reloadList={reloadList} isEdit={isEdit} />
            <ModalDataUmum showDataUmum={showDataUmum} handleCloseDataUmum={handleCloseDataUmum} dataPpmKapal={dataPpmKapal} dataDisposisi={dataDisposisi} reloadList={reloadList} isEdit={isEdit} />
            <ModalInspeksiChecklist showChecklist={showChecklist} handleCloseChecklist={handleCloseChecklist} dataPpmKapal={dataPpmKapal} dataDisposisi={dataDisposisi} reloadList={reloadList} isEdit={isEdit} />
            <ModalInspeksiChecklistHasil showHasilInspeksi={showHasilInspeksi} handleCloseHasilInspeksi={handleCloseHasilInspeksi} dataPpmKapal={dataPpmKapal} dataDisposisi={dataDisposisi} reloadList={reloadList} isEdit={isEdit} />
            <ModalRekom showRekom={showRekom} handleCloseRekom={handleCloseRekom} dataPpmKapal={dataPpmKapal} dataDisposisi={dataDisposisi} reloadList={reloadList} isEdit={isEdit} />
            <ModalApproval showApproval={showApproval} handleCloseApproval={handleCloseApproval} dataPpmKapal={dataPpmKapal} dataDisposisi={dataDisposisi} reloadList={reloadList} isEdit={isEdit} />
            <ModalPreview showPreview={showPreview} handleClosePreview={handleClosePreview} dataDisposisi={dataDisposisi} dataPpmKapal={dataPpmKapal} reloadList={reloadList} />
            <ModalPreviewTte showViewTte={showViewTte} handleCloseViewTte={handleCloseViewTte} dataDisposisi={dataDisposisi} dataPpmKapal={dataPpmKapal} />
            <ModalTindakLanjutSP showTLSP={showTLSP} handleCloseShowTLSP={handleCloseTLSP} dataDisposisi={dataDisposisi} dataPpmKapal={dataPpmKapal} reloadList={reloadList} isEdit={isEdit} />
            <ModalTindakLanjutEvp showTLEvp={showTLEvp} handleCloseShowTLEvp={handleCloseTLEvp} dataDisposisi={dataDisposisi} dataPpmKapal={dataPpmKapal} reloadList={reloadList} isEdit={isEdit} />
            <ModalProsesST showProsesST={showProsesST} handleCloseProsesST={handleCloseProsesST} dataPpmKapal={dataPpmKapal} reloadList={reloadList} isEdit={isEdit} />
        </>
    )
}

const GetNomorSertifikatKapal = ({ nomorAjuKapal, namaKapal, idDisposisi }) => {
    let kapalService = useMemo(() => new KapalService(), [])
    const [nomorSertifikat, setNomorSertifikat] = useState(null)

    const fetchAllData = useCallback(async () => {
        if (!nomorAjuKapal || idDisposisi !== 8) {
            return
        }

        try {
            const resSert = await kapalService.listKapalSertifikat(nomorAjuKapal, null, namaKapal)
            // console.log(resSert)
            if (resSert.data.data.length > 0) {
                setNomorSertifikat(resSert.data?.data[0].nomorSertifikat)
            }
        } catch (error) {
            console.log(error)
        }
    }, [nomorAjuKapal, idDisposisi, namaKapal, kapalService])

    useEffect(() => {
        let isMounted = true;
        if (!nomorAjuKapal || !idDisposisi) return;

        const loadData = async () => {
            try {
                await fetchAllData();
            } catch (e) {
                if (isMounted) console.error(e);
            }
        };

        loadData();

        return () => { isMounted = false; };
    }, [nomorAjuKapal, idDisposisi, fetchAllData]);

    return (
        <>
            {nomorSertifikat ? nomorSertifikat : '-'}
        </>
    )
}

const GetStatusTteSpt = ({ nomorAjuKapal, noTugas, idDisposisi }) => {
    let kapalService = useMemo(() => new KapalService(), [])
    const [statusTte, setStatusTte] = useState(null)

    const fetchAllData = useCallback(async () => {
        if (!nomorAjuKapal || !noTugas || idDisposisi !== 9) {
            return
        }

        try {
            const resSpt = await kapalService.getSptByAjuAndNomor(nomorAjuKapal, noTugas)
            if (resSpt) {
                setStatusTte(resSpt.data.stsTte)
            }
        } catch (error) {
            console.log(error)
        }
    }, [nomorAjuKapal, idDisposisi, kapalService, noTugas])

    useEffect(() => {
        let isMounted = true;
        if (!nomorAjuKapal || !idDisposisi || !noTugas) return;

        const loadData = async () => {
            try {
                await fetchAllData();
            } catch (e) {
                if (isMounted) console.error(e);
            }
        };

        loadData();

        return () => { isMounted = false; };
    }, [nomorAjuKapal, idDisposisi, fetchAllData, noTugas]);

    return (
        <>
            {statusTte === 0 ? <span className='text-danger'>Belum TTE</span>
                : statusTte === 1 ? <span className='text-info'>SPT Terkirim Portal, Menunggu TTE</span> :
                    statusTte === 2 ? <span className='text-success'>SPT Sudah TTE</span> : ''}
        </>
    )
}

const GetStatusTteSertifikat = ({ nomorAjuKapal, namaKapal, idDisposisi }) => {
    let kapalService = useMemo(() => new KapalService(), [])
    const [statusTte, setStatusTte] = useState(null)

    const fetchAllData = useCallback(async () => {
        if (!nomorAjuKapal || idDisposisi !== 8) {
            return
        }

        try {
            const resSert = await kapalService.listKapalSertifikat(nomorAjuKapal, null, namaKapal)
            if (resSert.data.data.length > 0) {
                setStatusTte(resSert.data?.data[0].stsTte)
            }
        } catch (error) {
            console.log(error)
        }
    }, [nomorAjuKapal, idDisposisi, namaKapal, kapalService])

    useEffect(() => {
        let isMounted = true;
        if (!nomorAjuKapal || !idDisposisi) return;

        const loadData = async () => {
            try {
                await fetchAllData();
            } catch (e) {
                if (isMounted) console.error(e);
            }
        };

        loadData();

        return () => { isMounted = false; };
    }, [nomorAjuKapal, idDisposisi, fetchAllData]);

    return (
        <>
            {statusTte === 0 ? <span className='text-danger'>Belum TTE</span>
                : statusTte === 1 ? <span className='text-info'>Sertifikat Terkirim Portal, Menunggu TTE</span> :
                    statusTte === 2 ? <span className='text-success'>Sertifikat Sudah TTE</span> : ''}
        </>
    )
}


export default ExpandableComponentKapal